import * as React from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import OrganisationPlanningSidebar from "./OrganisationPlanningSidebar";
import { Splitter } from "@progress/kendo-react-layout";
import { PageContainer, Content, Header } from "../Drawer/PageContainer";
import Loader from '../Shared/Loader/loader'
import ServerError from "../Shared/Error/ServerError";
import { getPlanningConfiguration } from "../../API/Planning/Planning";

class OrganisationPlanning extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            planningId: "",
            loading: true,
            panes: [
                { collapsible: false },
                { size: "475px", min: "475px", collapsible: false },
            ],
            SideData: [],
            selectedId: null,
            selected: 0,
            showServerError: false
        };
    }

    onSplitterSizeChange = (e) => {
        this.setState({ panes: e.newState });
    };

    componentDidMount = async () => {
        try {
            await this.getRequirementsData();
        } catch (error) {
            console.error(error)
            this.setState({
                showServerError: true
            })
        }
    };
    render() {
        if (this.state.showServerError) return <ServerError />
        if (this.state.loading) return <Loader />;
        return (
            <PageContainer>
                <Header header="Planning">
                    {/* <a href="#">Go to planning</a> */}
                </Header>
                <Content>
                    <Splitter
                        className="splitter-holder"
                        panes={this.state.panes}
                        onChange={this.onSplitterSizeChange}
                    >
                        <div className="m-3">
                            <Grid
                                data={this.state.data.map((item, index) => ({
                                    ...item,
                                    selected:
                                        item.fieldName === this.state.selectedId,
                                    indexId: index + 1,
                                }))}
                                onRowClick={this.rowClick}
                                style={{ height: "100%" }}
                                selectedField="selected"
                                resizable
                                reorderable={true}
                                id="entity_grid"
                            >
                                <Column
                                    field="indexId"
                                    title="#"
                                    width={40}
                                    minResizableWidth={40}
                                />
                                <Column field="fieldName" title="Field Name" />
                                <Column
                                    field="fieldValues"
                                    title="Field Values"
                                />
                            </Grid>
                        </div>
                        <div style={{ height: "100%" }}>
                            {
                                this.state.SideData &&
                                    this.state.SideData.data &&
                                    this.state.SideData.data.length > 0 ? (
                                    <OrganisationPlanningSidebar
                                        userRole={this.props.userRole}
                                        SideData={this.state.SideData}
                                        planningId={this.state.planningId}
                                        organisationData={this.props.organization}
                                        onSidebarchange={this.onSidebarchange}
                                    />
                                ) : null}
                        </div>
                    </Splitter>
                </Content>
            </PageContainer>
        );
    }

    getRequirementsData = async () => {
        let response = await getPlanningConfiguration(this.props.organization._id)
        debugger
        if (response && response.cardTypes.length > 0) {
            let fields = [
                {
                    databaseField: "cardTypes",
                    fieldName: "Card Type",
                    fieldValues: "",
                    data: [],
                },
                {
                    databaseField: "priorities",
                    fieldName: "Priority",
                    fieldValues: "",
                    data: [],
                },
                {
                    databaseField: "states",
                    fieldName: "State",
                    fieldValues: "",
                    data: [],
                },
            ];

            for (let field of fields) {
                let fielddata = response[field.databaseField];
                fielddata = fielddata.slice().sort((a, b) => a.order - b.order);
                field.data = fielddata;
                field.fieldValues = field.data.map((d) => d.key).join(", ");
            }
            this.setState({
                data: fields,
                planningId: response._id,
            }, () => {
                if (fields.length > 0) {
                    this.rowClick(fields[0]);
                }
            });
        } else {
            this.setState({
                loading: false,
            });
        }
    };

    onSidebarchange = (propsData) => {
        let data = this.state.data;
        let index = data.findIndex((item) => item._id === this.state.selectedId);
        data[index] = propsData;
        this.setState({ data: data });
    };

    rowClick = (value) => {
        this.setState({
            SideData: [],
        });
        var fieldName = "";
        if (value["dataItem"]) {
            fieldName = value.dataItem.fieldName;
        } else {
            fieldName = value.fieldName;
        }
        this.setState({ selectedId: fieldName });
        let element = this.state.data.find((x) => x.fieldName === fieldName);
        this.setState({ SideData: element, loading: false });
    };
}

export default OrganisationPlanning;
